import React from "react";
import { observer } from "mobx-react";
import {
  Pagination as BSPagination,
  DropdownButton,
  MenuItem,
} from "react-bootstrap";

@observer
export class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.itemsToDisplay = 6;
  }

  handlePageChange = async (page) => {
    const { currentPage, setCurrentPage, fetchSearchResults } = this.props;
    if (page && currentPage !== page && page <= this.getPagesCount()) {
      await setCurrentPage(page);
      fetchSearchResults();
    }
  };

  handlePerPageChange = (newPerPageValue) => {
    const { setCurrentPage, setPerPage, perPage } = this.props;
    if (newPerPageValue && newPerPageValue !== perPage) {
      setCurrentPage(1);
      setPerPage(newPerPageValue);
    }
  };

  getPagesCount = () => {
    const { perPage, totalResults } = this.props;
    return Math.ceil(totalResults / perPage);
  };

  getPaginationLinks = () => {
    const { currentPage } = this.props;
    const items = [];

    if (this.getPagesCount() > this.itemsToDisplay) {
      if (currentPage <= this.itemsToDisplay / 2) {
        for (let i = 1; i <= this.itemsToDisplay - 1; i++) {
          items.push(
            <BSPagination.Item
              key={`a-${i}`}
              onClick={() => this.handlePageChange(i)}
              active={i === currentPage}
            >
              {i}
            </BSPagination.Item>
          );
        }
        items.push(<BSPagination.Ellipsis key={"Ellipsis1"} />);
        items.push(
          <BSPagination.Item
            key={1}
            onClick={() => this.handlePageChange(this.getPagesCount())}
            active={currentPage === this.getPagesCount()}
          >
            {this.getPagesCount()}
          </BSPagination.Item>
        );
      } else if (currentPage > this.getPagesCount() - this.itemsToDisplay / 2) {
        items.push(
          <BSPagination.Item
            key={1}
            onClick={() => this.handlePageChange(1)}
            active={currentPage === 1}
          >
            1
          </BSPagination.Item>
        );
        items.push(<BSPagination.Ellipsis key={"Ellipsis2"} />);
        for (
          let i = this.getPagesCount() - this.itemsToDisplay + 2;
          i <= this.getPagesCount();
          i++
        ) {
          items.push(
            <BSPagination.Item
              key={1}
              onClick={() => this.handlePageChange(i)}
              active={i === currentPage}
            >
              {i}
            </BSPagination.Item>
          );
        }
      } else {
        items.push(<BSPagination.Ellipsis key={"Ellipsis3"} />);
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          items.push(
            <BSPagination.Item
              key={`b-${i}`}
              onClick={() => this.handlePageChange(i)}
              active={i === currentPage}
            >
              {i}
            </BSPagination.Item>
          );
        }
        items.push(<BSPagination.Ellipsis key={"Ellipsis4"} />);
      }
    } else {
      for (let i = 1; i < this.getPagesCount() + 1; i++) {
        items.push(
          <BSPagination.Item
            key={`c-${i}`}
            onClick={() => this.handlePageChange(i)}
            active={i === currentPage}
          >
            {i}
          </BSPagination.Item>
        );
      }
    }
    return items;
  };

  render() {
    const { currentPage, perPage } = this.props;
    const { dropup } = this.props;

    const pageCount = this.getPagesCount();

    if (pageCount !== 0) {
      return (
        <div className="pagination-wrapper">
          {pageCount > 1 ? (
            <BSPagination>
              <BSPagination.First
                onClick={() => this.handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <BSPagination.Prev
                onClick={() => this.handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {this.getPaginationLinks()}
              <BSPagination.Next
                onClick={() => this.handlePageChange(currentPage + 1)}
                disabled={currentPage === this.getPagesCount()}
              />
              <BSPagination.Last
                onClick={() => this.handlePageChange(pageCount)}
                disabled={currentPage === pageCount}
              />
            </BSPagination>
          ) : null}
          <DropdownButton
            bsStyle="default"
            title={`Items per page: ${perPage}`}
            dropup={dropup}
            id="perPage"
          >
            <MenuItem
              onSelect={() => this.handlePerPageChange(10)}
              active={perPage === 10}
            >
              10
            </MenuItem>
            <MenuItem
              onSelect={() => this.handlePerPageChange(20)}
              active={perPage === 20}
            >
              20
            </MenuItem>
            <MenuItem
              onSelect={() => this.handlePerPageChange(50)}
              active={perPage === 50}
            >
              50
            </MenuItem>
            <MenuItem
              onSelect={() => this.handlePerPageChange(100)}
              active={perPage === 100}
            >
              100
            </MenuItem>
            <MenuItem
              onSelect={() => this.handlePerPageChange(500)}
              active={perPage === 500}
            >
              500
            </MenuItem>
            <MenuItem
              onSelect={() => this.handlePerPageChange(1000)}
              active={perPage === 1000}
            >
              1000
            </MenuItem>
          </DropdownButton>
        </div>
      );
    }
    return null;
  }
}
